import MarkdownIt from 'markdown-it';
import MarkdownItIns from 'markdown-it-ins';
import htmlSanitize from './htmlSanitize';

export interface MarkdownOptions extends MarkdownIt.Options {
  instance?: MarkdownIt;
  init?: (md: MarkdownIt) => void;
  emptyLinesToBreaks?: boolean;
}

export function markdownInstance(
  options: MarkdownIt.Options & Pick<MarkdownOptions, 'init'> = {},
) {
  const { init, ...rest } = options || {};
  const md = new MarkdownIt(rest);
  md.use(MarkdownItIns);
  if (init) init(md);
  return md;
}

export default function markdown(text: string, options: MarkdownOptions = {}) {
  const { emptyLinesToBreaks, ...opts } = options || {};
  if (emptyLinesToBreaks) {
    text = text.replaceAll(
      /\n(\n+)\n/gm,
      (_, nl) => '\n\n' + nl.replaceAll(/\n/g, '<br/>') + '\n\n',
    );
  }
  const md = opts.instance || markdownInstance(opts);
  const rendered = md.render((text || '').toString());
  return htmlSanitize(rendered);
}
